import { render, staticRenderFns } from "./AvatarComponent.vue?vue&type=template&id=4d1d0f7a&scoped=true&"
import script from "./AvatarComponent.vue?vue&type=script&lang=ts&"
export * from "./AvatarComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarComponent.vue?vue&type=style&index=0&id=4d1d0f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1d0f7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VLabel } from 'vuetify/lib/components/VLabel';
installComponents(component, {VAvatar,VLabel})
